import {
  RoadmapContainer,
  CurveLineWrapper,
  LineStart,
  CurveLineRightOne,
  CurveLineLeftOne,
  CurveLineRightTwo,
  CurveLineLeftTwo,
  CurveLineRightThree,
  Step,
  Start,
  Finish,
  LineFinish,
} from "./RoadmapStyle";
import { useDispatch, useSelector } from "react-redux";
import {
  updateCurrentLesson,
  updateLessonsRange,
} from "../../../features/lessons/lessonSlice";

const arr1 = [1, 2, 3, 4, 5];
const arr2 = [10, 9, 8, 7, 6];
const arr3 = [11, 12, 13, 14, 15];
const arr4 = [20, 19, 18, 17, 16];
const arr5 = [21, 22, 23, 24, 25];
const arr6 = [30, 29, 28, 27, 26];

/**
 * Props:
 * - mode: "student" | "teacher"  (default "student")
 * - lessons: optional array of lessons (when omitted we use logged-in student's lessons from Redux)
 * - onTeacherUnlock: function(lessonOrder) => void   (teacher mode only)
 * - selectedStudentName: string, just for confirm text
 */
const Roadmap = ({
  mode = "student",
  lessons: lessonsProp,
  onTeacherUnlock,
  selectedStudentName,
  guestClick
}) => {
  const dispatch = useDispatch();

  const token = useSelector((state) => state.auth?.token);
  const role = useSelector((state) => state.auth?.user?.role); // ✅ add
  const isPrivileged = role === "TEACHER" || role === "ADMIN"; // ✅ add

  // Logged-in student's lessons (for normal student mode)
  const { lessons: studentLessons } = useSelector(
    (state) => state.studentLessons
  );

  // If teacher passes lessonsProp, use that; otherwise fallback to student's own lessons.
  const lessons = lessonsProp || studentLessons || [];

  const getLessonStatus = (lessonNumber) => {

    // ✅ TEACHER/ADMIN browsing as themselves: everything open
    if (mode === "student" && isPrivileged) {
      return { isUnlocked: true, isCompleted: false };
    }
    // ✅ GUEST fallback: allow only lesson 1
    if (mode === "student" && !token) {
      return {
        isUnlocked: lessonNumber === 1,
        isCompleted: false,
      };
    }

    const lesson = lessons.find((l) => l.order === lessonNumber);

    if (!lesson) {
      return { isUnlocked: false, isCompleted: false };
    }

    return {
      isUnlocked: !!lesson.isUnlocked,
      isCompleted: !!lesson.isCompleted,
    };
  };

  const assignLesson = (lessonNumber) => {
    dispatch(updateCurrentLesson(lessonNumber));
    let rangeNumber = 1;

    switch (true) {
      case lessonNumber < 7:
        rangeNumber = 1;
        break;
      case lessonNumber < 13:
        rangeNumber = 7;
        break;
      case lessonNumber < 19:
        rangeNumber = 13;
        break;
      case lessonNumber < 25:
        rangeNumber = 19;
        break;
      case lessonNumber < 31:
        rangeNumber = 25;
        break;
      default:
        break;
    }

    dispatch(updateLessonsRange(rangeNumber));
  };

  const renderStep = (value, index) => {
    const { isUnlocked, isCompleted } = getLessonStatus(value);
    const locked = !isUnlocked;

    const handleClick = (e) => {
          guestClick()
      // 🔹 TEACHER MODE
      // guestClick()
      if (mode === "teacher") {
        e.preventDefault();

        // If already unlocked -> show "Already unlocked"
        if (isUnlocked) {
          window.alert("Already unlocked");
          return;
        }

        const nameForText =
          selectedStudentName && selectedStudentName.trim().length > 0
            ? selectedStudentName
            : "this student";

        const confirmed = window.confirm(
          `Are you sure you want to unlock this lesson for ${nameForText}?`
        );
        if (!confirmed) return;

        if (typeof onTeacherUnlock === "function") {
          onTeacherUnlock(value); // value is the lesson ORDER (1..30)
        }
        return;
      }

      // 🔹 STUDENT MODE (existing behaviour)
      if (locked) {
        e.preventDefault();
        return;
      }
      assignLesson(value);
    };

    // In teacher mode we stay on the same page; in student mode we navigate to lesson page
    const linkTarget =
      mode === "teacher" ? "#" : locked ? "#" : "/myprogress/lesson";

    return (

      <Step
        key={index}
        id={value}
        to={linkTarget}
        onClick={handleClick}
        data-locked={locked ? "true" : "false"}
        data-completed={isCompleted ? "true" : "false"}
        isUnlocked={isUnlocked}
        role={role}
      >
        {value}
      </Step>
    );
  };

  return (
    <RoadmapContainer>
      <CurveLineWrapper>
        <Start>Start</Start>
        <LineStart></LineStart>

        <CurveLineRightOne>{arr1.map(renderStep)}</CurveLineRightOne>
        <CurveLineLeftOne>{arr2.map(renderStep)}</CurveLineLeftOne>
        <CurveLineRightTwo>{arr3.map(renderStep)}</CurveLineRightTwo>
        <CurveLineLeftTwo>{arr4.map(renderStep)}</CurveLineLeftTwo>
        <CurveLineRightThree>{arr5.map(renderStep)}</CurveLineRightThree>
        <LineFinish>{arr6.map(renderStep)}</LineFinish>

        <Finish>Finish</Finish>
      </CurveLineWrapper>
    </RoadmapContainer>
  );
};

export default Roadmap;
